import { FixedState } from './types'

const state = (): FixedState => ({
  activeSectionId: 0,
})

export default state
